module.exports = __webpack_public_path__ + "img/learnModel-ball-sm-mobile.d6969892.png";